import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import * as footerStyles from "./footer.module.scss"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
    }
  `)

  return (
    <footer className={footerStyles.footer}>
      <p>
        Built with <a href="https://www.gatsbyjs.com/">Gatsby</a> · Created{" "}
        {data.site.siteMetadata.author} © 2022
      </p>
    </footer>
  )
}

export default Footer
